import { render, staticRenderFns } from "./DonorCoMorbiditiesPrint.vue?vue&type=template&id=55328f80"
import script from "./DonorCoMorbiditiesPrint.vue?vue&type=script&lang=js"
export * from "./DonorCoMorbiditiesPrint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports